// cleanCountryOptions.js
import raw from './CountryJson.json';

const unique = Array.from(new Map(raw.map(i => [i.cc, i])).values());
export default unique;